import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import AppointmentTypeButtonContainer from '../AppointmentTypeButton/AppointmentTypeButtonContainer.js';

const VirtualAppointmentButtonContainer = (_param)=>{
    var { className , appointmentType  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "appointmentType"
    ]);
    return appointmentType ? /*#__PURE__*/ React.createElement(AppointmentTypeButtonContainer, swcHelpers.extends({}, rest, {
        className: classnames('virtual-appointment-type-button', className),
        icon: "video-call",
        appointmentType: appointmentType
    })) : null;
};
var VirtualAppointmentButtonContainer$1 = VirtualAppointmentButtonContainer;

export { VirtualAppointmentButtonContainer$1 as default };
//# sourceMappingURL=VirtualAppointmentButtonContainer.js.map
